import React, { useState, useEffect } from 'react'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'

import lang from '@/lang'
import TenantCollaboratorsService from '@/modules/tenant/tenantCollaboratorsService'
import clsx from 'clsx'

const useStyles = makeStyles(theme => ({
  tooltipWrapper: {
    color: theme.black,

    '& p': {
      margin: 0,
    },
  },
  companyName: {
    fontSize: theme.fontSizes.default,
    fontWeight: theme.fontWeights.semiBold,
  },
  section: {
    marginTop: 10,
    fontSize: theme.fontSizes.smaller,
    lineHeight: '20px',

    '& label': {
      color: '#aaaaaa',
      fontSize: theme.fontSizes.tiny,
    },
  },
}))

const ProfileDetailsTooltip = ({ user, tenantCollaborationId, styles = {} }) => {
  const classes = useStyles()
  const [client, setClient] = useState(null)
  const { companyAddress: address, senderEmail: email, companyName } = user

  const getCollaborator = async(tenantCollaborationId) => {
    const collaborators = await TenantCollaboratorsService.getCollaborators()
    if (collaborators && collaborators?.data?.length) {
      const taxConsultantTenant = collaborators.data.find(collaboratorUser => {
        if (collaboratorUser.tenantCollaborations.id === tenantCollaborationId.toString()) {
          return true
        }
      })
      if (taxConsultantTenant) {
        setClient(taxConsultantTenant.tenantCollaborations)
      }
    }
  }

  useEffect(() => {
    if (tenantCollaborationId) getCollaborator(tenantCollaborationId)
  }, [tenantCollaborationId])

  const rootClassName = clsx(classes.tooltipWrapper, styles?.root && styles?.root)
  return (
    <div className={rootClassName}>
      <p className={classes.companyName}>{companyName || lang.menu.profileSection.noCompanyName}</p>

      { tenantCollaborationId && client && <div className={classes.section}>
        <label>{lang.menu.profileSection.clientNumber}</label>
        <p>{client.clientNumber || '-'}</p>
      </div>}

      <div className={classes.section}>
        <label>{lang.customerContactForm.address}</label>
        <p>
          {address
            ? <>
              {address.street}<br />
              {address.zipCode} {address.city}<br />
              {address.country} {address.countryIso}
            </>
            : '-'
          }
        </p>
      </div>

      <div className={classes.section}>
        <label>{lang.emailLabel}</label>
        <p>{email || '-'} </p>
      </div>

      <div className={classes.section}>
        <label>{lang.phoneLabel}</label>
        <p>{address?.phone1 || '-'}</p>
      </div>

      <div className={classes.section}>
        <label>{lang.customerContactForm.website}</label>
        <p>{address?.website || '-'}</p>
      </div>
    </div>
  )
}

ProfileDetailsTooltip.propTypes = {
  user: PropTypes.object.isRequired,
  tenantCollaborationId: PropTypes.number,
}

ProfileDetailsTooltip.defaultProps = {
  tenantCollaborationId: null,
}

export default ProfileDetailsTooltip
